import React from 'react';
import { Switch } from 'react-router-dom';
import FaceConfig from '../containers/face_config';
import TicketUserFaceDetail from '../containers/face_config/detail';
import PaymentIndex from '../containers/payment';
import PassIndex from '../containers/pass';
import PublicRoute from './public.router';

// Page
import PurchaseIndex from '../containers/purchase';
import PurchaseNotFound from '../containers/purchase/not_found';
import TicketIndex from '../containers/ticket';
import ChangeDateIndex from '../containers/change_date';
import ChangeDateSearch from '../containers/change_date/search';
import PaymentDateIndex from '../containers/payment/date';
import OpenDateIndex from '../containers/open_date';
import MyInvoisIndex from '../containers/myinvois';
import MyInvoisStatus from '../containers/myinvois/status';

const AppRouter = () => {
    return (
        <>
            <Switch>
                {/* Home */}
                {/* Purchase */}
                <PublicRoute component={PurchaseIndex} path="/" exact restricted={false} />
                <PublicRoute component={PurchaseNotFound} path="/not_found" exact restricted={false} />

                {/* Purchase Open Date Route */}
                <PublicRoute component={OpenDateIndex} path="/open_date" exact restricted={false} />

                {/* Ticket Configuration */}
                <PublicRoute component={FaceConfig} path="/ticket/face/:token" exact restricted={false} />
                <PublicRoute component={TicketUserFaceDetail} path="/ticket/user/:ticket_user_id" exact restricted={false} />
                <PublicRoute component={PassIndex} path="/ticket/pass/:pass_code" exact restricted={false} />

                {/* Payment */}
                <PublicRoute component={PaymentIndex} path="/payment/:running_number" exact restricted={false} />
                <PublicRoute component={PaymentDateIndex} path="/payment/date/:running_number" exact restricted={false} />

                {/* Ticket */}
                <PublicRoute component={TicketIndex} path="/ticket/:ticket_id" exact restricted={false} />

                {/* Date Changing */}
                <PublicRoute component={ChangeDateIndex} path="/date/change/:token" exact restricted={false} />
                <PublicRoute component={ChangeDateSearch} path="/date/search" exact restricted={false} />

                {/* MALAYSIA EINVOICE */}
                <PublicRoute component={MyInvoisIndex} path="/myinvois/:token" exact restricted={false} />
                <PublicRoute component={MyInvoisStatus} path="/myinvois/document/:document_id" exact restricted={false} />
            </Switch>
        </>
    );
}

export default AppRouter;